export default __webpack_public_path__ + "static/media/img-0495-holy-see-full-face.acdf8d19.png";